// eslint-disable-next-line import/order
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDraggable } from 'react-use-draggable-scroll';

import '../../../styles/animations.scss';
import '../../../styles/Screens/onboarding/home/newHome.scss';

import { getExistence } from '../../../api/User.api';
import invalidIcon from '../../../assets/cross_home.svg';
import loadingAnim from '../../../assets/loading.gif';
import rightArrow from '../../../assets/right-arrow.svg';
import Button from '../../../components/Button';
import Celebs from '../../../components/Celebs';
import FooterNew from '../../../components/FooterNew';
import ImageButton from '../../../components/ImageButton';
import NewHeader from '../../../components/NewHeader';
import TextInput from '../../../components/TextInput';
import { SIGN_UP_FORM } from '../../../constants/FormNames';
import { ValidationTypes } from '../../../enums/ValidationTypes';
import celebrities from './celebrities';
import faqData from './faq';
import featuresData from './features';

export default function Home({ formData }) {
	const history = useHistory();

	const [usernameValid, setUsernameValid] = useState(false);

	const ref =
		useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
	const { events } = useDraggable(ref);
	const [roundBtnImg, setRoundBtnImg] = useState(rightArrow);
	const [faq, setFaq] = useState<any>([]);
	const [isMobile, setMobile] = useState(false);

	const handleGetStartedbBtn = () => {
		const section = document.querySelector(`#usernameSection`);
		section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	const handleUserNameBtnm = () => {
		if (!usernameValid) return;
		history.push('/signup');
	};

	const showAnswer = id => {
		console.log(id);
		const index = faq.indexOf(faq.find(f => f.id === id));
		if (index === -1) return;
		faq[index].visible = !faq[index].visible;
		setFaq([...faq]);
	};

	useEffect(() => {
		setFaq([...faqData]);
	}, [faqData]);

	const validateUserName = async () => {
		const validity: any = await getExistence({
			name: formData.username?.toLowerCase(),
		});
		setRoundBtnImg(validity.exists ? invalidIcon : rightArrow);
		setUsernameValid(!validity.exists);
	};

	useEffect(() => {
		if (!formData.username) {
			setRoundBtnImg(rightArrow);
			setUsernameValid(false);
			return;
		}
		setRoundBtnImg(loadingAnim);
		setUsernameValid(false);
		const timeOutId = setTimeout(() => {
			formData.username.trim() && validateUserName();
		}, 2000);
		return () => clearTimeout(timeOutId);
	}, [formData.username]);

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			setMobile(width > 768 ? false : true);
		};
		handleResize();
		window.addEventListener('resize', handleResize, false);
	}, []);

	return (
		<div className='wrapper'>
			<NewHeader />
			<div className='onboarding-section' id='onboarding'>
				<div className='container'>
					<div className='col-md-7'>
						<div className='title'>Create your personal website</div>
						<div className='subtitle'>
							Your bio, social media, links, achievements, photos and videos in one
							place!
						</div>
						<Button
							labal="Let's get started!"
							className={'get-started-button'}
							onClickEvent={handleGetStartedbBtn}
							clicked={false}
						/>
					</div>
				</div>
			</div>
			<div className='username-section' id='usernameSection'>
				<div className='container'>
					<div className='title'>Claim your username</div>
					<div className='subtitle'>all social media links in one place</div>
					<div className='seperator-vertical'></div>
					<div className='username-container'>
						<div className='left'>
							<span className='url-preview'>webbler.me/ </span>
							<TextInput
								errDisable
								type='text'
								name='username'
								placeholder='username'
								transform='lower'
								id='username'
								form={SIGN_UP_FORM}
								validations={[ValidationTypes.required]}
								hidden={false}
								rightSideIcon={null}
								mainIcon={null}
								onEnterKey={handleUserNameBtnm}
							/>
						</div>
						<ImageButton
							className={
								roundBtnImg === loadingAnim
									? 'round-border loading-btn'
									: roundBtnImg === invalidIcon
									? 'round-border invalid-btn'
									: 'round-border'
							}
							image={roundBtnImg}
							onClickHandler={handleUserNameBtnm}
							disabled={!usernameValid}
						/>
					</div>
				</div>
			</div>
			<div className='features-section' id='featuresSection'>
				{featuresData?.map((feature, index) => {
					return (
						<div key={index} className={index % 2 != 0 ? 'feature dark' : 'feature'}>
							<div className='container'>
								{(index % 2 === 0 || isMobile) && (
									<div className='lottie-container col-md-5'>
										<img src={feature.animation} />
									</div>
								)}
								<div className='feature-content col-md-5'>
									<div className='feature-title'>{feature.title}</div>
									<div className='feature-description'>{feature.content}</div>
								</div>

								{index % 2 != 0 && !isMobile && (
									<div className='lottie-container col-md-5'>
										<img src={feature.animation} />
									</div>
								)}
							</div>
						</div>
					);
				})}
			</div>
			<div className='vip-section' id='vipSection'>
				<div className='featured-container'>
					<div className='container'>
						<div className='title'>Featured People</div>
					</div>
					<div
						className='flex max-w-xl space-x-3 overflow-x-scroll scrollbar-hide square_set'
						{...events}
						ref={ref}
					>
						{celebrities?.map((item, index) => (
							<Celebs
								key={index}
								firstName={item.firstName}
								lastName={item.lastName}
								designation={item.designation}
								image={item.image}
								color={item.color}
							/>
						))}
					</div>
				</div>
			</div>
			<div className='faq-section' id='faqSection'>
				<div className='container'>
					<div className='title'>Frequently Asked Questions</div>
					{faq.map((q, index) => {
						return (
							<div className='qna' key={index}>
								<div className='question' onClick={() => showAnswer(q.id)}>
									{q.question}
									<i
										className={q.visible ? 'fa fa-chevron-up rotate' : 'fa fa-chevron-up'}
										aria-hidden='true'
									></i>
								</div>
								{q.visible && <div className='answer scale-in-ver-top'>{q.answer}</div>}
							</div>
						);
					})}
				</div>
			</div>
			<FooterNew />
		</div>
	);
}
